// Browser/extension password managers (Chrome, 1Password, LastPass, Bitwarden, Dashlane, Proton Pass)
// use their own heuristics to detect "login-like" fields and ignore autoComplete="off".
// These data attributes are each manager's dedicated opt-out, needed alongside autoComplete
// to stop save/fill prompts on plain name/email fields (e.g. adding a guest player).
export const PASSWORD_MANAGER_IGNORE_INPUT_PROPS = {
  autoComplete: 'off',
  'data-1p-ignore': true,
  'data-lpignore': true,
  'data-bwignore': true,
  'data-form-type': 'other',
  'data-protonpass-ignore': true,
} as const;
